import { EscalaTrabalho } from "./EscalaTrabalho";
import { MBase } from "./MBase";
import { Usuario } from "./Usuario";
import * as moment from 'moment';

export class Funcionario extends MBase {
    Nome:string = "";
    Funcao:string = "";
    EscalaTrabalhoId: number;
    Ativo: boolean = true;

    //auxiliar
    Checked: boolean = false;
    UsuarioCadastro: Usuario;
    UsuarioAlteracao: Usuario;
    EscalaTrabalho: EscalaTrabalho;

    get descAtivo(): string{
      return this.Ativo ? 'Ativo' : 'Inativo'
    }

    get dataAlteracaoStr(): string{
      return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
    }
}
